import { SpreadsheetCell, SheetMatrix, toRows } from "../../lib/spreadsheetRows";

export type { SpreadsheetCell, SheetMatrix };

const SpreadsheetPreview = ({
  cells,
}: {
  cells?: SpreadsheetCell[] | SheetMatrix | null;
}) => {
  const rows = toRows(cells);

  if (rows.length === 0) {
    return (
      <p style={{ color: "#9ca3af", fontSize: "0.875rem" }}>Empty spreadsheet</p>
    );
  }

  return (
    <table
      style={{
        borderCollapse: "collapse",
        fontSize: "0.8rem",
        minWidth: "100%",
      }}
    >
      <tbody>
        {rows.map((row, r) => (
          <tr key={r}>
            {row.map((cell, c) => (
              <td
                key={c}
                style={{
                  border: "1px solid #e2e8f0",
                  padding: "4px 8px",
                  minWidth: "60px",
                  whiteSpace: "pre-wrap",
                }}
              >
                {cell}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default SpreadsheetPreview;
